module.exports = {
  src: __webpack_public_path__ + "assets/images/plus.d081203a620f77c1.svg",
  width: 17,
  height: 17,
  toString: function() { return __webpack_public_path__ + "assets/images/plus.d081203a620f77c1.svg"; }
};